module.exports = __webpack_public_path__ + "img/logo-large.23857b7c.jpg";